var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "errorPage"
  }, [_vm._m(0), _vm.data.text ? _c('p', [_vm._v(_vm._s(_vm.data.text))]) : _vm._e(), _c('p', [_vm._v(_vm._s(_vm.data.content) + " "), _c('router-link', {
    attrs: {
      "to": _vm.data.url
    }
  }, [_vm._v(_vm._s(_vm.data.linkText))])], 1)])]);
};

var staticRenderFns = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('p', [_c('img', {
    attrs: {
      "src": require("@/assets/images/error404.png"),
      "alt": ""
    }
  })]);
}];
export { render, staticRenderFns };